import { useState } from 'react';

import { NgButton } from '@/ui';
import { incidentListRoute } from '@/features/shared/routes';
import { createDemoIncidents } from './demoApi';

const LANGUAGES: readonly string[] = ['en', 'cs'];

export function DemoHelperPage() {
  const [isCreating, setIsCreating] = useState(false);

  const createDemoIncidentsForLanguage = async (selectedLanguage: string) => {
    try {
      setIsCreating(true);
      await createDemoIncidents(selectedLanguage);

      window.location.href = incidentListRoute();
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <div className="container p-3">
      {isCreating ? (
        <div className="spinner-border spinner-border-sm opacity-50" style={{ margin: '.46rem' }} role="status">
          <span className="visually-hidden"> Creating...</span>
        </div>
      ) : (
        LANGUAGES.map((language) => (
          <NgButton
            key={language}
            cssClass="me-2"
            onClick={() => void createDemoIncidentsForLanguage(language)}
          >
            Create demo incidents {language}
          </NgButton>
        ))
      )}
    </div>
  );
}
